module.exports = __webpack_public_path__ + "img/cir.79258fac.svg";